/* @flow */
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Row } from 'react-grid-system';
import {
  Button,
  Checkbox,
  Images,
  InputClearable,
  LoadingIndicator,
  Modal,
  ModalTitle,
  PromptText,
  Input,
} from 'listertech-commons-web';
import { callUpdateContractor, callGetOne } from '../../api/users';

const ModalButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-width: 400px;
  margin-top: 40px;

  > * {
    width: auto;
    padding: 0px 20px;
  }
`;

const Title = styled(ModalTitle)`
  display: inline-block;
`;

const TitleExtra = styled.p`
  display: inline-block;
  margin: 0;
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  line-height: 17px;
  color: #9da8ae;
`;

const Label = styled(TitleExtra)`
  font-size: 16px;
`;

const Icon = styled.img`
  width: 18px;
  height: 18px;
  margin-left: 12px;
`;

const IconLabel = styled(Label)`
  margin-left: 12px;
`;

const List = styled.div`
  margin-top: 12px;
  max-height: 300px;
  overflow-y: scroll;
  overflow-x: hidden;
`;

const ListItem = styled.div`
  display: flex;
  margin-top: 12px;
`;

const RegionsModal = props => {
  const { contractor, onClose } = props;

  const [regionsText, setRegionsText] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (contractor?.autoAccept.regions) {
      setRegionsText(contractor.autoAccept?.regions.join(', '));
    }
  }, [contractor]);

  const handleChange = (e) => {
    setRegionsText(e.target.value);
  };

  const handleSave = async () => {
    const trimmedRegions = regionsText
      .split(',')
      .map(r => r.trim())
      .filter(r => r); // Remove empty strings

    setSaving(true);
    try {
      await callUpdateContractor(contractor._id, {
        'autoAccept.regions': trimmedRegions,
      });
      onClose(); // Close after save
    } catch (err) {
      alert('Failed to update regions.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal visible>
      <Row justify="space-between" align="baseline">
        <Title>Modify Regions</Title>
        <TitleExtra>{contractor && contractor.name}</TitleExtra>
      </Row>
      <Row style={{ marginTop: 20 }}>
        <Input
          label="Auto-Accept Regions (comma-separated)"
          value={regionsText}
          onChange={handleChange}
          placeholder="e.g., 33602, 33805, 34230"
          fullWidth
        />
      </Row>
        <ModalButtons>
                <Button noMargin theme="light" onClick={onClose}>
                  Exit
                </Button>
                <Button onClick={handleSave} loading={saving} noMargin>
                    Save
                </Button>
        </ModalButtons>
    </Modal>
  );
};

export default RegionsModal;
